<template>
  <div class="home">
    <Welcome v-if="!isLoggedIn" />
    <AppShell v-else />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStorage } from '@/stores'
import Welcome from '@/views/Welcome.vue'
import AppShell from '@/shell/AppShell.vue'

const store = useStorage()
const isLoggedIn = computed(() => store.isLoggedIn)
</script>

<style scoped>
.home {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100svh;
  background: #09090e;
}
</style>
